import {
  Container,
  Grid,
  Title,
  Text,
  Button,
  Image,
  Group,
} from "@mantine/core";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Element } from "react-scroll";
import Layout from "../../layout/Layout";
import Projects from "../Projects/Projects";
import Resume from "../Resume/Resume";
import Contact from "../Contact/Contact";
import UndrawImage from "../../assets/images/undraw_software_engineer_lvl5.svg";
import classes from "./Home.module.css";

export default function Home() {
  const texts = [
    "Alvian Ardhiansyah",
    "Backend Developer",
    "Frontend Developer",
    "DevOps Engineer",
  ]; // List teks yang akan berganti
  const [index, setIndex] = useState(0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 3000); // Ganti teks setiap 2 detik

    return () => clearInterval(interval);
  }, [texts.length]);

  return (
    <HelmetProvider>
      <Layout>
        <Element name="about">
          <section style={{ display: "flex", alignItems: "center" }}>
            <Container>
              <Grid gutter="lg" align="center" style={{ paddingTop: "5rem" }}>
                {/* Kolom Kiri - Text */}
                <Grid.Col order={{ md: 2, lg: 1 }} span={{ xs: 12, md: 7 }}>
                  <div>
                    <Title order={1} mt="sm">
                      <span>Hey folks, I'm </span>
                      {/* Animasi Fade Up */}
                      <motion.span
                        key={texts[index]} // Kunci agar animasi terjadi setiap teks berubah
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.5 }}
                        style={{
                          display: "inline-block",
                          fontWeight: "bold",
                          fontSize: "2rem",
                          marginLeft: "2px",
                        }}
                      >
                        {texts[index]}
                      </motion.span>
                    </Title>

                    <Text mt="md">
                      Building a successful product is a challenge. I am highly
                      energetic in API, web development, and server.
                    </Text>

                    <Group mt="xl">
                      <Button
                        className={classes.btnPrimary}
                        size="md"
                        color="blue"
                        leftIcon={<i className="uil uil-file-alt"></i>}
                      >
                        Download Resume
                      </Button>
                    </Group>
                  </div>
                </Grid.Col>

                {/* Kolom Kanan - Gambar */}
                <Grid.Col order={{ md: 1, lg: 2 }} span={{ xs: 12, md: 5 }}>
                  <Image
                    src={UndrawImage}
                    alt="Software Engineer Illustration"
                    radius="md"
                    fit="contain"
                  />
                </Grid.Col>
              </Grid>
            </Container>
          </section>
        </Element>
        <Projects />
        <Resume />
        <Contact />
      </Layout>
    </HelmetProvider>
  );
}
